import React from 'react';

import Accordion from 'components/Accordion';
import TitleSemiBold from 'components/Typography/TitleSemiBold';
import { WindxTela } from 'helper/windx';

import Lista from './Lista';
import FormSalvar from './FormSalvar';
import useSavedPreferences, { SavedPreferencesSnapshot } from './useSavedPreferences';

interface SavedPreferencesProps {
  tela: Extract<WindxTela, 'sh' | 'sm' | 'comparativo'>;
  showSaveForm: boolean;
  onCloseSaveForm: () => void;
  snapshot: SavedPreferencesSnapshot;
}

/**
 * Casca desktop das Preferencias Salvas: `Accordion.Item` em volta da `Lista`,
 * com o `FormSalvar` como irmao.
 *
 * O corpo (lista + form) e o estado (`useSavedPreferences`) sao compartilhados
 * com o painel mobile — este arquivo so decide a casca. Ver
 * `Windx/Mobile/ControlPanelSheet/Preferencias`.
 */
export default function SavedPreferences({
  tela,
  showSaveForm,
  onCloseSaveForm,
  snapshot,
}: SavedPreferencesProps) {
  const {
    prefs, isLoadingList, isDeleting, isSaving,
    nome, setNome, handleRestore, handleDelete, handleDismiss, handleSave,
  } = useSavedPreferences({ tela, snapshot, onCloseSaveForm });

  return (
    <>
      <Accordion.Item eventKey="saved-preferences">
        <Accordion.Header>
          <TitleSemiBold>Preferências Salvas</TitleSemiBold>
        </Accordion.Header>
        <Accordion.Body>
          <Lista
            prefs={prefs}
            isLoadingList={isLoadingList}
            isDeleting={isDeleting}
            onRestore={handleRestore}
            onDelete={handleDelete}
          />
        </Accordion.Body>
      </Accordion.Item>

      <FormSalvar
        open={showSaveForm}
        isSaving={isSaving}
        nome={nome}
        onNomeChange={setNome}
        onDismiss={handleDismiss}
        onSubmit={handleSave}
      />
    </>
  );
}
